import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {DuplicateContactModel} from '../../api/models/duplicate-contact-model';
import {ContactService} from '../contact.service';
import {ContactModel} from '../../api/models/contact-model';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { NgFor } from '@angular/common';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';

export interface DuplicatesWarningData {
  records: Array<ContactModel>;
}

@Component({
    selector: 'app-duplicate-warning-dialog',
    template: `
    <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
      <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
        <div fxFlex>Duplicate Contacts</div>
        <button mat-icon-button [mat-dialog-close]="false" class="button-40">
          <mat-icon>close</mat-icon>
        </button>
      </h1>
      <div mat-dialog-content style="display: flex; align-items: stretch;">
        <div fxFlex class="stretched-container">
          <p-table [value]="data.records" [columns]="tableColumns" styleClass="p-datatable-sm" [resizableColumns]="true"
                   columnResizeMode="expand"
                   [scrollable]="true" scrollHeight="flex">
            <ng-template pTemplate="colgroup">
              <colgroup>
                <col style="width: 300px">
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pResizableColumn *ngFor="let col of columns">
                  {{ col.title }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-columns="columns">
              <tr>
                <td>
              <span>
                {{ item.firstName }} {{ item.lastName }}
              </span>
                </td>
                <td>{{ item.phoneNumber  | phoneNumber }}</td>
                <td>{{ item.mobileNumber  | phoneNumber }}</td>
                <td>{{ item.faxNumber  | phoneNumber }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.companyName }} {{ item.position }}</td>
                <td>{{ item.recordType == 0 ? 'Company' : 'Private' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div mat-dialog-actions style="justify-content: flex-end;">
        <button mat-button (click)="closeSendConfirmPopup('proceed')">Save Anyway</button>
        <button mat-button (click)="closeSendConfirmPopup('close')">Close</button>
      </div>
    </div>
  `,
    styles: [
        '.stretched-container {overflow: auto;}'
    ],
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, TableModule, PrimeTemplate, NgFor, MatDialogActions, MatButton, PhoneNumberPipe]
})
export class DuplicatesWarningDialogComponent {

  tableColumns = [
    {title: 'Name'},
    {title: 'Phone Number'},
    {title: 'Mobile Number'},
    {title: 'Fax Number'},
    {title: 'Email Address'},
    {title: 'Company Name'},
    {title: 'Directory'},
  ];

  constructor(public dialogRef: MatDialogRef<DuplicatesWarningDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DuplicatesWarningData,
              public dialog: MatDialog,
              public contactService: ContactService,
  ) {

  }

  closeSendConfirmPopup(action: string) {
    this.dialogRef.close(action);
  }
}
